import React from "react";
import { Container } from "@mui/material";
import { useLocation } from "react-router-dom";
import NavMenu from "./NavMenu";

// Export/print views are meant to be a clean, standalone document (often opened to print or
// embed), so the app bar / nav is hidden on those routes.
const HIDE_NAV_PREFIXES = ["/export-form", "/export-all"];

const Layout = (props) => {
  const { pathname } = useLocation();
  const hideNav = HIDE_NAV_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  return (
    <div>
      {!hideNav && <NavMenu />}
      <Container sx={{ pb: 4 }}>{props.children}</Container>
    </div>
  );
};

export default Layout;
